import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel } from '@mui/material'
import Icon from '@mui/icons-material/Check'
import { useTranslation } from 'shared/hooks/useSafeTranslation'

import useStyle from 'shared/hooks/useStyle'
import EmptyIcon from './EmptyIcon'

import styles from './SummaryChoicesList.style'

const propTypes = {
    choiceLabel: PropTypes.string.isRequired,
    choiceIdentifier: PropTypes.string.isRequired,
    isAnswered: PropTypes.bool,
    choice: PropTypes.string,
}

const SummaryChoicesItem = ({
    choice,
    choiceLabel,
    choiceIdentifier,
    isAnswered = false,
}) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()

    return (
        <FormControlLabel
            css={[
                classes.formControlStyle,
                classes.itemLabel,
                (isAnswered && choiceIdentifier !== choice) ? classes.notSelectedText : null,
            ]}
            label={t(`processDefinition:${choiceLabel}`)}
            control={
                choice === choiceIdentifier
                    ? (
                        <Icon
                            css={classes.icon}
                        />
                    ) : (<EmptyIcon />)
            }
        />

    )
}

SummaryChoicesItem.propTypes = propTypes

export default SummaryChoicesItem
